// extracted by mini-css-extract-plugin
export default {"newsWrapper":"News_newsWrapper__4SITE"};